export default "/Frontend/dist/logo.1f94ee7d31cbc5791de31963c3c4536c.svg";